import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { LanguageSpecificationListingProvider } from "./context/LanguageSpecificationListingProvider";
import { LanguageSpecificationListing } from "./LanguageSpecificationListing";

export const LanguageSpecificationPage: React.FC = () => {
    return (
        <LanguageSpecificationListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <LanguageSpecificationListing />
        </LanguageSpecificationListingProvider>
    );
};
